import Splide from "@splidejs/splide";
// import { Intersection } from "@splidejs/splide-extension-intersection";
/**
 * Initializes the Sliders component.
 */

const Sliders = () => {
    const blogSliders = document.querySelectorAll('.blog-module__posts--slider');

    if(blogSliders.length > 0) {
        blogSliders.forEach(function (slider) {

            const perPage = parseInt(slider.dataset.perpage);
            const perPageTablet = parseInt(slider.dataset.perpageTablet);
            const perPageMobile = parseInt(slider.dataset.perpageMobile);
            const autoplay = slider.dataset.autoplay === 'true';
            const interval = parseInt(slider.dataset.interval);
            const arrows = slider.dataset.arrows === 'true';
            const pagination = slider.dataset.pagination === 'true';

            new Splide(slider, {
                type: 'loop',
                perPage: perPage,
                perMove: 1,
                autoplay: autoplay,
                interval: interval,
                arrows: arrows,
                pagination: pagination,
                pauseOnHover: false,
                pauseOnFocus: false,
                resetProgress: false,
                breakpoints: {
                    1024: {
                        perPage: perPageTablet
                    },
                    767: {
                        perPage: perPageMobile
                    }
                }
            }).mount();
        });
    }
};

export default Sliders;
